import { email, authType } from "./store";

export { email, authType };
